__turbopack_context__.v({
  "article": "FeaturedArticle-module-scss-module__FZtKTa__article",
  "borderless": "FeaturedArticle-module-scss-module__FZtKTa__borderless",
  "content": "FeaturedArticle-module-scss-module__FZtKTa__content",
  "content-block": "FeaturedArticle-module-scss-module__FZtKTa__content-block",
  "dark": "FeaturedArticle-module-scss-module__FZtKTa__dark",
  "description": "FeaturedArticle-module-scss-module__FZtKTa__description",
  "featured-article": "FeaturedArticle-module-scss-module__FZtKTa__featured-article",
  "rounded": "FeaturedArticle-module-scss-module__FZtKTa__rounded",
  "section": "FeaturedArticle-module-scss-module__FZtKTa__section",
  "thumbnail": "FeaturedArticle-module-scss-module__FZtKTa__thumbnail",
  "thumbnail-wrapper": "FeaturedArticle-module-scss-module__FZtKTa__thumbnail-wrapper",
});
